import React from 'react';
import { Error } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';

export const NoCommercialAgreement: React.FC = () => {
  return (
    <Box
      component={Paper}
      elevation={1}
      variant="outlined"
      sx={(t) => ({
        zIndex: 1,
        p: 1,
        mb: 2,
        display: 'flex',
        flexDirection: 'row',
        position: 'sticky',
        top: 0,
        border: `1px solid ${t.palette.error.main}`,
      })}
    >
      <Error sx={{ mr: 1 }} color="error" />
      <Typography>
        <Typography variant="body2">
          No commercial agreement found. You must have a commercial agreement to create paid
          credentials.
        </Typography>
      </Typography>
    </Box>
  );
};
